import React, { useMemo } from "react";
import "./Disclaimer.css";
import { useLocalContext } from "../../context/LocalContext";

const Disclaimer = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "webantidigi.com",
      email: webinfo.email || "contact@webantidigi.com",
      phone: webinfo.phone || "+1 (000) 000-0000",
      phonecall: webinfo.phonecall || "+10000000000",
      address: webinfo.address || "United States",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="disclaimerv2">
      <div className="dv2-wrap">
        <header className="privacy-policy-header">
          <p className="pp-eyebrow">Important Notice</p>
          <div className="pp-header-main">
            <h1>Website Disclaimer</h1>
          </div>
          <p className="pp-meta">
            <span>Issued by: {brand.name}</span>
            <span>Last updated: {effectiveDate}</span>
          </p>
        </header>

        <div className="privacy-policy-content">
          <section>
            <h2>1. Independent provider disclosure</h2>
            <p>
              {brand.name} is an independent service provider. Unless explicitly
              stated, we are not officially affiliated with third-party brands
              mentioned on this website.
            </p>
          </section>

          <section>
            <h2>2. Informational purpose</h2>
            <p>
              Content on this site is provided for general information. It should
              not be treated as legal, tax, financial, or professional advice.
            </p>
          </section>

          <section>
            <h2>3. No guaranteed outcomes</h2>
            <p>
              Examples, results, and performance references are illustrative only.
              Actual outcomes vary based on multiple factors outside our control.
            </p>
          </section>

          <section>
            <h2>4. Platform and policy compliance</h2>
            <p>
              We aim to follow U.S.-focused disclosure standards and major ad
              platform policy expectations, including clear and non-misleading
              communication.
            </p>
          </section>

          <section>
            <h2>5. External links and third parties</h2>
            <p>
              Links to external websites are provided for convenience only. We are
              not responsible for third-party content, policies, or practices.
            </p>
          </section>

          <section>
            <h2>6. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, this website and services are
              provided "as is." We disclaim liability for indirect or consequential
              losses related to website use.
            </p>
          </section>

          <section>
            <h2>7. Contact</h2>
            <ul className="pp-contact-list">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
